if (process.env.REACT_APP_TARGET === 'embed') {
  import('./embedIndex');
} else {
  import('./appIndex');
}

export {};
